import axios from "axios";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";

const HandleUpdateCheckbox = async (field, newValues, targetID, route) => {
  try {
    
    await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
      [field]: newValues,
    })

  } catch (e) {
    toast.error("Error al actualizar el dato: " + e);
  }
}

export default HandleUpdateCheckbox